var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 462.68 110.31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;fill-rule:evenodd;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M76.27,81.63A37,37,0,0,1,53.58,89.2,37.64,37.64,0,0,1,17,61.14H75.33V44.44H17a37.61,37.61,0,0,1,59.57-20.8l1,.63,9.14-12.93-.63-.62A54.26,54.26,0,0,0,53.58,0C24,0,0,23.64,0,52.64s24,52.63,53.58,52.63A53.31,53.31,0,0,0,85.73,94.56l1-.63L77.22,81.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M267,4.1V62.41c0,8.82-1.58,15.75-5.36,20.48-4.42,6-11.35,8.83-21.12,8.83s-17-2.84-21.43-8.83c-3.47-4.73-5.36-11.66-5.36-20.48V4.1h-17V66.51c0,23.32,17.65,38.76,43.81,38.76S284,89.83,284,66.51V4.1H267Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M380.74,4.1H364.35V62.41c0,8.82-1.9,15.75-5.36,20.48-4.41,6-11.67,8.83-21.43,8.83s-17-2.84-21.12-8.83c-3.78-4.73-5.36-11.66-5.36-20.48V4.1h-17V66.51c0,23.32,17.33,38.76,43.5,38.76s43.5-15.44,43.5-38.76V4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.42,52.32c0-29-23.32-52.32-51.69-52.32a52.17,52.17,0,0,0,0,104.33,56.68,56.68,0,0,0,18-3.16l-8.51-13.24a47.36,47.36,0,0,1-9.46.95c-20.17,0-36.87-16.39-36.87-36.56a36.92,36.92,0,0,1,36.87-36.87A36.46,36.46,0,0,1,174.3,52.32a37.5,37.5,0,0,1-10.1,25.22h-.3v.31c-1,1.26-3.47,3.16-7.25,5.36l-2.21,1.57,9.14,15.14,6.62,10.39,12.6-8.5s-7.56-12-8.19-13.24a52.66,52.66,0,0,0,14.81-36.25"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M432.43,43.5l-8.52-2.84c-10.39-3.47-15.75-7.88-15.75-13.24,0-7.88,9.77-13.23,18.91-13.23,8.19,0,13.87,2.51,18.28,8.82l.32.63L459.22,17l-.63-.94C452,6.3,440.94.63,427.38.63c-17.34,0-35.93,9.46-35.93,26.79,0,14.5,12.61,20.8,26.48,25.85l8.19,2.83C435.58,59.57,446,64,446,74.07c0,10.4-9.15,18.6-21.11,18.6a24.31,24.31,0,0,1-17-6.63A15.08,15.08,0,0,1,402.8,74.7l.32-1.26-17,3.15v1c2.52,16.39,18.59,28.36,37.5,28.36,22.38,0,39.08-13.55,39.08-31.83S447.55,48.22,432.43,43.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo-white.d4cff671b1a4a3ce52066f69d28915c8.svg";
export { ForwardRef as ReactComponent };